import { Box, Typography } from '@material-ui/core';
import React from 'react';
import useStyles from './dialog.styles';
import { StageValidationError } from './helpers';

interface ValidationPanelProps {
  errors: StageValidationError[]
}

const ValidationPanel: React.FC<ValidationPanelProps> = ({ errors }) => {
  const classes = useStyles();

  if (!errors.length) {
    return null;
  }

  return (
    <Box className={classes.validationPanel}>
      {errors.map((error, index) => (
        <Typography key={`${error.stageNumber}-${index}`}
          className={classes.validationError}>
          • {error.message}
        </Typography>
      ))}
    </Box>
  );
};

export default ValidationPanel;
